// 福利 type=9

import mixin from './mixin'

export default {
  mixins: [mixin],

  render () {
    const {
      list, // from mixins
      style, // from mixins
      onClick // from mixin
    } = this

    return (
      <section class={style.block}>
        <h2 class={style.title}>{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}福利</h2>
        <ul class={style.floatBox}>
          {
            list.map(item => (
              <li class={style.floatItem}>
                <img
                  class={style.img2}
                  src={item.imageUrl}
                  alt={item.number}
                  onClick={() => onClick(item)}
                />
              </li>
            ))
          }
        </ul>
      </section>
    )
  }
}
